'use client'

import { BuilderBlocks } from '@builder.io/react'
import dayjs from 'dayjs'
import React, { createContext, useState } from 'react'

import { useCountdown } from '@src/hooks/useCountDown'

export const CountdownContext = createContext<any>({})

interface CountdownWrapperProps {
  children: React.ReactNode
  startTime: Date
  endTime: Date
  includedChildren: any[]
  completionMessage: string
  builderBlock: any
  behavior: 'static' | 'dynamic'
  dynamicMinutes: number
  dynamicSeconds: number
  dynamicDays: number
  dynamicHours: number
}

export default function CountdownWrapper({
  children,
  startTime,
  endTime,
  includedChildren,
  builderBlock,
  completionMessage,
  behavior,
  dynamicDays,
  dynamicHours,
  dynamicMinutes,
  dynamicSeconds,
}: CountdownWrapperProps) {
  const shouldRenderBuilderBlocks = () => {
    return !React.Children.count(children)
  }
  const getDynamicTime = () => {
    const currentDate = dayjs()
    const date = currentDate
      .add(dynamicDays, 'day')
      .add(dynamicHours, 'hour')
      .add(dynamicMinutes, 'minute')
      .add(dynamicSeconds, 'second')
    return date.toDate()
  }
  // used as state since this component always updates because of useCountdown hook
  const [dynamicTime] = useState(getDynamicTime())
  const currentEndTime = behavior === 'dynamic' ? dynamicTime : endTime
  const currentCountdown = useCountdown(currentEndTime) as any
  const isCountdownFinished =
    currentCountdown.seconds < 0 ||
    currentCountdown.minutes < 0 ||
    currentCountdown.hours < 0 ||
    currentCountdown.days < 0

  return (
    <div>
      <CountdownContext.Provider value={{ startTime, endTime: currentEndTime, currentCountdown }}>
        {!isCountdownFinished ? (
          <div className="flex flex-row">
            {shouldRenderBuilderBlocks()
              ? includedChildren?.map((child, index) => (
                  <BuilderBlocks
                    key={index}
                    parentElementId={builderBlock?.id}
                    dataPath={`component.options.includedChildren.${index}.item`}
                    blocks={child.item}
                    className="!flex flex-row! items-center!"
                    style={{ minHeight: 'auto !important' }}
                  />
                ))
              : children}
          </div>
        ) : (
          <span dangerouslySetInnerHTML={{ __html: completionMessage }} className="builder-text" />
        )}
      </CountdownContext.Provider>
    </div>
  )
}
